import { AuthLayout } from 'features';
import { safiLogo } from 'features/brand';
import { Trans, useTranslation } from 'i18n';
import { Button, Link, Typography } from 'ui';

export const SignUpSuccess = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');

  return (
    <AuthLayout
      title={t('shared.marketingTitle')}
      subtitle={t('shared.marketingSubtitle', { values: { brandName: tCommon('brand.name') } })}
      logo={safiLogo}
    >
      <Typography variant="h5" fontWeight="bold">
        {t('signUpSuccess.title')}
      </Typography>
      <Typography>{t('signUpSuccess.paragraphOne', { values: { brandName: tCommon('brand.name') } })}</Typography>
      <Typography>{t('signUpSuccess.paragraphTwo', { values: { brandName: tCommon('brand.name') } })}</Typography>
      <Typography>
        <Trans
          namespace="auth"
          i18nKey="signUpSuccess.bookCall"
          components={{
            introCallLink: <Link href="https://meetings-eu1.hubspot.com/alex-stewart3/intro-call" />,
          }}
        />
      </Typography>
      <Typography>{t('signUpSuccess.explorePlatform')}</Typography>

      <Button type="submit" size="large" onClick={() => (window.location.href = '/quality-control/')}>
        {t('shared.next')}
      </Button>
    </AuthLayout>
  );
};
